
(function(){
  var root=document.getElementById('eblp'); if(!root) return;
  // Keep the offer visible after the complete hero has scrolled past the header.
  var hdr=document.getElementById('hdr'), hero=root.querySelector('.hero');
  function upd(){
    if(!hdr||!hero)return;
    var past=hero.getBoundingClientRect().bottom<=hdr.getBoundingClientRect().bottom;
    root.classList.toggle('ceb-after-hero',past);
    hdr.classList.toggle('cta-on',past);
  }
  if(hdr&&hero){
    window.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd);
    window.addEventListener('pageshow',upd);
    if(window.ResizeObserver)new ResizeObserver(upd).observe(hero);
    upd();
  }
  // gallery
  var main=document.getElementById('galmain'), ths=[].slice.call(document.querySelectorAll('#thumbs .th')), cur=0;
  function show(i){ cur=(i+ths.length)%ths.length; ths.forEach(function(t,k){t.classList.toggle('on',k===cur);});
    if(ths[cur]) ths[cur].parentElement.scrollTo({left:ths[cur].offsetLeft-ths[0].offsetLeft,behavior:'smooth'});
    var src=ths[cur].querySelector('img'); if(src&&main){ var big=main.querySelector('img');
      if(big){ big.src=src.src; big.srcset=src.srcset; big.sizes='(min-width: 920px) 560px, calc(100vw - 36px)'; big.alt=src.alt; } } }
  ths.forEach(function(t){ t.addEventListener('click',function(){ show(+t.dataset.i); }); });
  var p=document.getElementById('prev'), n=document.getElementById('next');
  if(p) p.addEventListener('click',function(){show(cur-1);}); if(n) n.addEventListener('click',function(){show(cur+1);});
  // tabs
  var tabs=[].slice.call(document.querySelectorAll('#tabs .tab')), panes=[].slice.call(document.querySelectorAll('#tabs .pane'));
  tabs.forEach(function(t){ t.addEventListener('click',function(){ var i=+t.dataset.t;
    tabs.forEach(function(x,k){ x.classList.toggle('on',k===i); x.setAttribute('aria-selected',k===i?'true':'false'); });
    panes.forEach(function(x,k){ x.classList.toggle('on',k===i); x.hidden=(k!==i); }); }); });

  // flavor picker: exactly 2 of 4, and the CTAs stay locked until 2 are chosen
  var FV_MAX = 2, flavg = document.getElementById('flavg'), flav = document.getElementById('flav');
  if (flavg) {
    var picked = [].slice.call(flavg.querySelectorAll('.fv.on'));
    function fvPaint() {
      var n = picked.length, note = document.getElementById('flavnote'), root = document.getElementById('eblp');
      if (n === 0) { note.className = 'flav-n need'; note.innerHTML = '<span class="dot"></span>Select 2 flavors'; }
      else if (n === 1) { note.className = 'flav-n need'; note.innerHTML = '<span class="dot"></span>Select 1 more flavor'; }
      else { note.className = 'flav-n ok'; note.textContent = '2 of 2 selected'; }
      if (root) root.classList.toggle('flav-lock', n < FV_MAX);
      [].forEach.call(document.querySelectorAll('.cta, .sticky .ceb-purchase'), function (c) {
        if (n < FV_MAX) { c.setAttribute('aria-disabled', 'true'); } else { c.removeAttribute('aria-disabled'); }
      });
    }
    flavg.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.fv') : null; if (!b) return;
      var i = picked.indexOf(b);
      if (i > -1) { picked.splice(i, 1); b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); }
      else {
        if (picked.length >= FV_MAX) { var old = picked.shift(); old.classList.remove('on'); old.setAttribute('aria-pressed', 'false'); }
        picked.push(b); b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
      }
      fvPaint();
    });
    // a CTA clicked with fewer than 2 flavors sends them back to the picker instead
    document.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('.cta, .sticky .ceb-purchase') : null;
      if (!c || picked.length >= FV_MAX) return;
      e.preventDefault(); e.stopPropagation();
      if (flav) { flav.scrollIntoView({ block: 'center', behavior: 'smooth' });
        flav.classList.remove('flash'); void flav.offsetWidth; flav.classList.add('flash'); }
    }, true);
    fvPaint();
  }
})();

(function () {
  'use strict';
  var offerElement = document.getElementById('ceb-offer');
  if (!offerElement) return;
  var offer = JSON.parse(offerElement.textContent);
  var root = document.getElementById('eblp');
  var status = document.getElementById('ceb-checkout-status');
  var ctas = Array.from(root.querySelectorAll('.ceb-purchase, a.cta, .sticky a, a.hcta'));
  var buttons = Array.from(root.querySelectorAll('#flavg .fv'));
  var busy = false, attempt = null, uncertain = false;
  var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var variants = new Map((offer.product.variants || []).map(function(v){ return [String(v.id), v]; }));
  function plan(v) { return v && (v.selling_plan_allocations || []).find(function(a){return a.selling_plan_id === offer.sellingPlan;}); }
  function selected() { return buttons.filter(function(b){return b.classList.contains('on');}); }
  function announce(message) { status.textContent = message; status.focus({preventScroll:true}); }
  function setBusy(value) {
    busy = value;
    ctas.forEach(function(c){ c.setAttribute('aria-busy', String(value)); if(c.tagName==='BUTTON')c.disabled=value; });
    buttons.forEach(function(b){ b.disabled = value || b.dataset.unavailable === 'true'; });
  }
  buttons.forEach(function(b){
    var v = variants.get(b.dataset.variantId);
    if (!v || !v.available || !plan(v)) {
      b.disabled = true; b.dataset.unavailable = 'true'; b.classList.remove('on'); b.setAttribute('aria-pressed','false');
      b.setAttribute('aria-label', b.getAttribute('aria-label') + ' - unavailable');
    }
  });
  async function request(endpoint, data) {
    var response = await fetch(route + endpoint, data ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data),credentials:'same-origin'} : {credentials:'same-origin',cache:'no-store'});
    var result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || 'Your cart could not be updated. Please try again.');
    return result;
  }
  function bundleLines(cart) {return cart.items.filter(function(i){return i.properties && String(i.properties['Bundle ID']) === attempt.id;});}
  function validate(cart) {
    var lines = bundleLines(cart);
    if(lines.length !== 5) throw new Error('Please review your cart before continuing. Your full welcome kit could not be confirmed.');
    for(var id of attempt.ids){var line=lines.find(function(i){return i.variant_id===id;});if(!line || line.quantity!==1 || !line.selling_plan_allocation || line.selling_plan_allocation.selling_plan.id!==offer.sellingPlan)throw new Error('Please review your cart. We could not confirm your selected flavors and subscription.');}
    for(var giftId of offer.giftIds){var gift=lines.find(function(i){return i.variant_id===giftId;});if(!gift || gift.quantity!==1 || gift.final_line_price!==0 || gift.selling_plan_allocation)throw new Error('Please review your cart. We could not confirm the free welcome-kit discount.');}
  }
  function checkout() {
    var url = new URL(route+'checkout', location.origin);
    new URLSearchParams(location.search).forEach(function(value,key){if(/^utm_|^(gclid|fbclid|ttclid|clickid|rtkcid|lpv)$/.test(key))url.searchParams.set(key,value);});
    location.assign(url.href);
  }
  document.addEventListener('click', async function(e){
    var c=e.target.closest && e.target.closest('.ceb-purchase, a.cta, .sticky a, a.hcta');
    if(!c || !root.contains(c))return;
    e.preventDefault();e.stopImmediatePropagation();
    if(busy)return;
    var choices=selected();
    if(choices.length!==2){announce('Please choose two flavors.');document.getElementById('flav').scrollIntoView({block:'center',behavior:'smooth'});return;}
    if(choices.some(function(b){var v=variants.get(b.dataset.variantId);return !v || !v.available || !plan(v);})){announce('One of these flavors is unavailable. Please choose another.');return;}
    setBusy(true);announce('Preparing your flavors and free welcome kit…');
    try {
      // An uncertain previous response must be checked before another add, so retries cannot duplicate a bundle.
      if(attempt && uncertain){var existing=await request('cart.js');if(bundleLines(existing).length){validate(existing);document.dispatchEvent(new CustomEvent('ceb:cart-updated',{detail:existing}));checkout();return;}}
      attempt={id:'ceb-'+Date.now()+'-'+Math.random().toString(36).slice(2,10),ids:choices.map(function(b){return Number(b.dataset.variantId);})};
      var props={'Bundle ID':attempt.id};
      var items=offer.giftIds.map(function(id){return {id:id,quantity:1,properties:props};}).concat(attempt.ids.map(function(id){return {id:id,quantity:1,selling_plan:offer.sellingPlan,properties:{'Bundle ID':attempt.id,Bundle:'Variety Pack'}};}));
      uncertain=true;
      await request('cart/add.js',{items:items});
      var cart=await request('cart.js');validate(cart);
      document.dispatchEvent(new CustomEvent('ceb:cart-updated',{detail:cart}));
      checkout();
    } catch(error) {
      announce(error.message || 'We could not confirm your cart. Please review it before trying again.');
      var link=document.createElement('a');link.href=route+'cart';link.dataset.cebCartOpen='';link.textContent=' Review cart';status.appendChild(link);
      setBusy(false);
    }
  },true);
  setBusy(false);
  window.addEventListener('pageshow',function(e){if(e.persisted){attempt=null;uncertain=false;setBusy(false);status.textContent='';}});
})();

(function () {
  'use strict';
  var root = document.getElementById('eblp');
  var trigger = root && root.querySelector('.hicon-l[href="/cart"]');
  if (!trigger || !window.HTMLDialogElement) return;
  var offer = JSON.parse(document.getElementById('ceb-offer').textContent);
  var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var dialog = document.createElement('dialog');
  dialog.id = 'ceb-cart';
  dialog.className = 'ceb-cart';
  dialog.setAttribute('aria-labelledby', 'ceb-cart-title');
  dialog.innerHTML = '<header class="ceb-cart-head"><div><h2 id="ceb-cart-title">Your cart</h2><p class="ceb-cart-count"></p></div><button type="button" class="ceb-cart-close" aria-label="Close cart" autofocus><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button></header><div class="ceb-cart-scroll"><p class="ceb-cart-status" role="status" aria-live="polite"></p><button type="button" class="ceb-cart-retry" hidden>Try again</button><div class="ceb-cart-items"></div></div><footer class="ceb-cart-footer" hidden><div class="ceb-cart-subtotal"><span>Subtotal</span><strong></strong></div><p class="ceb-cart-renewal"></p><p class="ceb-cart-shipping">Shipping and taxes calculated at checkout.</p><button type="button" class="ceb-cart-checkout">Continue to checkout <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg></button><button type="button" class="ceb-cart-continue">Continue shopping</button></footer>';
  root.appendChild(dialog);
  var badge = document.createElement('span');
  badge.className = 'ceb-cart-badge'; badge.hidden = true; badge.setAttribute('aria-hidden', 'true');
  trigger.appendChild(badge); trigger.classList.add('ceb-cart-trigger');
  trigger.setAttribute('aria-haspopup', 'dialog'); trigger.setAttribute('aria-controls', dialog.id); trigger.setAttribute('aria-expanded', 'false');
  var list = dialog.querySelector('.ceb-cart-items'), status = dialog.querySelector('.ceb-cart-status');
  var footer = dialog.querySelector('.ceb-cart-footer'), retry = dialog.querySelector('.ceb-cart-retry');
  var checkoutButton = dialog.querySelector('.ceb-cart-checkout');
  var currentCart = null, pendingRead = null, mutating = false, leaving = false, opener = trigger;
  var currency = 'USD';
  function money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:currency}).format(cents / 100); }
  function element(tag, className, text) { var el=document.createElement(tag); if(className)el.className=className; if(text!==undefined)el.textContent=text; return el; }
  async function request(endpoint, data) {
    var response = await fetch(route + endpoint, data ? {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {credentials:'same-origin',cache:'no-store'});
    var result = await response.json();
    if(!response.ok || result.status>=400)throw new Error('Your cart could not be updated. Please try again.');
    return result;
  }
  function setBusy() {
    checkoutButton.disabled = mutating || leaving || !!pendingRead || !currentCart || !currentCart.item_count;
    dialog.querySelectorAll('.ceb-cart-remove').forEach(function(b){b.disabled=mutating || leaving || !!pendingRead;});
    dialog.setAttribute('aria-busy', String(mutating || leaving || !!pendingRead));
  }
  function updateBadge(cart) {
    badge.textContent = String(cart.item_count); badge.hidden = cart.item_count===0;
    trigger.classList.toggle('ceb-cart-has-items', cart.item_count>0);
    trigger.setAttribute('aria-label', 'Cart, '+cart.item_count+' '+(cart.item_count===1?'item':'items'));
  }
  function renderLine(item) {
    var row=element('li','ceb-cart-item'); row.dataset.variantId=item.variant_id;
    if(item.image){var img=element('img');img.src=item.image;img.alt='';img.width=72;img.height=72;row.appendChild(img);}
    var copy=element('div','ceb-cart-copy');copy.appendChild(element('h4','',item.product_title || item.title));
    if(item.variant_title && item.variant_title!=='Default Title')copy.appendChild(element('p','ceb-cart-detail',item.variant_title));
    copy.appendChild(element('p','ceb-cart-detail','Quantity: '+item.quantity));
    var allocation=item.selling_plan_allocation;
    if(allocation)copy.appendChild(element('p','ceb-cart-detail',allocation.selling_plan.id===offer.sellingPlan?'Renews every 90 days':allocation.selling_plan.name));
    else if(offer.giftIds.includes(item.variant_id) && item.final_line_price===0)copy.appendChild(element('p','ceb-cart-detail','Welcome gift · first order'));
    var pricing=element('div','ceb-cart-price');
    var original=Math.max(item.original_line_price,allocation ? (allocation.compare_at_price || 0)*item.quantity : 0);
    if(original>item.final_line_price){var originalEl=element('s','',money(original));originalEl.setAttribute('aria-label','Original price '+money(original));pricing.appendChild(originalEl);}
    var finalEl=element('strong',item.final_line_price===0?'ceb-cart-free':'',item.final_line_price===0?'FREE':money(item.final_line_price));
    finalEl.setAttribute('aria-label','Current price '+(item.final_line_price===0?'free':money(item.final_line_price)));pricing.appendChild(finalEl);
    copy.appendChild(pricing); row.appendChild(copy); return row;
  }
  function render(cart) {
    currentCart=cart;currency=cart.currency || 'USD';updateBadge(cart);list.replaceChildren();
    dialog.querySelector('.ceb-cart-count').textContent=cart.item_count+' '+(cart.item_count===1?'item':'items');
    footer.hidden=!cart.item_count;status.textContent='';retry.hidden=true;
    if(!cart.item_count){
      var empty=element('div','ceb-cart-empty');empty.appendChild(element('h3','','Your cart is empty'));
      empty.appendChild(element('p','','Choose your two flavors to start your morning routine.'));
      var shop=element('button','ceb-cart-shop','Choose your flavors');shop.type='button';shop.addEventListener('click',function(){dialog.close();document.getElementById('flav').scrollIntoView({block:'center',behavior:'smooth'});root.querySelector('#flavg .fv:not(:disabled)').focus({preventScroll:true});});
      empty.appendChild(shop);list.appendChild(empty);setBusy();return;
    }
    var groups=new Map();
    cart.items.forEach(function(item){var bundle=item.properties && item.properties['Bundle ID'];var key=bundle?'bundle:'+bundle:'item:'+item.key;if(!groups.has(key))groups.set(key,{bundle:bundle,items:[]});groups.get(key).items.push(item);});
    groups.forEach(function(group){
      var section=element('section','ceb-cart-group'), head=element('div','ceb-cart-group-head');
      var knownKit=group.bundle && group.items.some(function(i){return i.selling_plan_allocation && i.selling_plan_allocation.selling_plan.id===offer.sellingPlan;});
      var name=group.bundle?(knownKit?'90-Day Variety Pack':'Your bundle'):(group.items[0].product_title || group.items[0].title);
      head.appendChild(element('h3','',name));
      var remove=element('button','ceb-cart-remove',group.bundle?'Remove kit':'Remove');remove.type='button';remove.setAttribute('aria-label','Remove '+name);
      remove.addEventListener('click',function(){removeGroup(group);});head.appendChild(remove);section.appendChild(head);
      var rows=element('ul');group.items.slice().sort(function(a,b){return Number(offer.giftIds.includes(a.variant_id))-Number(offer.giftIds.includes(b.variant_id));}).forEach(function(item){rows.appendChild(renderLine(item));});section.appendChild(rows);list.appendChild(section);
    });
    dialog.querySelector('.ceb-cart-subtotal strong').textContent=money(cart.total_price);
    var recurring=cart.items.some(function(i){return i.selling_plan_allocation && i.selling_plan_allocation.selling_plan.id===offer.sellingPlan;});
    var note=dialog.querySelector('.ceb-cart-renewal');note.hidden=!recurring;note.textContent='Your subscription renews every 90 days. Welcome gifts are included with your first order.';
    setBusy();
  }
  function showError(message) {status.textContent=message;retry.hidden=false;checkoutButton.disabled=true;}
  async function refresh() {
    if(mutating)return;
    if(pendingRead)return pendingRead;
    retry.hidden=true;
    if(dialog.open)status.textContent='Loading your cart…';
    pendingRead=request('cart.js').then(render).catch(function(){if(dialog.open)showError('We couldn’t load your cart. Please try again.');currentCart=null;}).finally(function(){pendingRead=null;setBusy();});
    setBusy();return pendingRead;
  }
  async function removeGroup(group) {
    if(mutating || pendingRead || leaving)return;
    mutating=true;setBusy();status.textContent='Updating your cart…';retry.hidden=true;
    try{
      // Read fresh line keys: discounts and other tabs can change them after the drawer opens.
      var cart=await request('cart.js'), updates={};
      cart.items.forEach(function(item){if(group.bundle ? item.properties && item.properties['Bundle ID']===group.bundle : item.key===group.items[0].key)updates[item.key]=0;});
      if(Object.keys(updates).length)cart=await request('cart/update.js',{updates:updates});
      render(cart);status.textContent=group.bundle?'Kit removed from your cart.':'Item removed from your cart.';
      dialog.querySelector('.ceb-cart-close').focus({preventScroll:true});
    }catch(error){currentCart=null;showError(error.message || 'We couldn’t update your cart. Please try again.');}
    finally{mutating=false;setBusy();}
  }
  function open(from) {
    opener=from || trigger;
    if(!dialog.open){dialog.showModal();document.documentElement.classList.add('ceb-cart-is-open');trigger.setAttribute('aria-expanded','true');}
    refresh();
  }
  dialog.querySelector('.ceb-cart-close').addEventListener('click',function(){dialog.close();});
  dialog.querySelector('.ceb-cart-continue').addEventListener('click',function(){dialog.close();});
  dialog.addEventListener('close',function(){document.documentElement.classList.remove('ceb-cart-is-open');trigger.setAttribute('aria-expanded','false');if(opener && opener.isConnected)opener.focus({preventScroll:true});});
  var backdropDown=false;
  dialog.addEventListener('pointerdown',function(e){backdropDown=e.target===dialog && e.clientX<dialog.getBoundingClientRect().left;});
  dialog.addEventListener('click',function(e){if(backdropDown && e.target===dialog)dialog.close();backdropDown=false;});
  trigger.addEventListener('click',function(e){if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();open(trigger);});
  document.addEventListener('click',function(e){var link=e.target.closest && e.target.closest('[data-ceb-cart-open]');if(link && root.contains(link)){e.preventDefault();open(link);}});
  retry.addEventListener('click',refresh);
  checkoutButton.addEventListener('click',function(){
    if(checkoutButton.disabled)return;
    leaving=true;setBusy();status.textContent='Opening secure checkout…';
    var url=new URL(route+'checkout',location.origin);
    new URLSearchParams(location.search).forEach(function(value,key){if(/^utm_|^(gclid|fbclid|ttclid|clickid|rtkcid|lpv)$/.test(key))url.searchParams.set(key,value);});
    location.assign(url.href);
  });
  document.addEventListener('ceb:cart-updated',function(e){render(e.detail);});
  window.addEventListener('pageshow',function(){leaving=false;refresh();});
  document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
  refresh();
})();
